const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
export const fixNumbers = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const proviencesList = [
  {
    name: "تهران",
    value: "tehran",
  },
  {
    name: "اصفهان",
    value: "esfahan",
  },
];

export const typeRecordList = [
  {
    name: "درمان",
    value: "darman",
    records: [
      {
        name: "اعتراض به مبلغ پرداختی",
      },
      {
        name: "اعتراض به عدم پاسخگوئی CRM",
      },
      {
        name: "اعتراض به بازه زمانی ثبت مدارک",
      },
      {
        name: "اعتراض به نحوه پاسخگوئی نامناسب",
      },
      {
        name: "اعتراض به تاخیر در پرداخت خسارت",
      },
      {
        name: "اعتراض به علت عودت مدارک درمانی",
      },
      {
        name: "اعتراض به نحوه ثبت مدارک درمانی",
      },
      {
        name: "سایر",
      },
    ],
  },
  {
    name: "خودرو",
    value: "khodro",
    records: [
      {
        name: "اعتراض به ارزیابی کارشناس سیار",
      },
      {
        name: "اعتراض به مبلغ پرداختی بیمه گر",
      },
      {
        name: "اعتراض به بازه زمانی ارسال پرونده به بیمه گ",
      },
      {
        name: "اعتراض به عدم ثبت پرونده ",
      },
      {
        name: "اعتراض به عدم پرداخت پس از ثبت",
      },
      {
        name: "اعتراض به پاسخگوئی نامناسب",
      },
      {
        name: "اعتراض به عدم پاسخگوئی",
      },
      {
        name: "سایر",
      },
    ],
  },
];

export const citiesList = [
  {
    provience: "tehran",
    city: [
      {
        name: "تهران",
        value: "tehran",
      },
      {
        name: "شهریار",
        value: "shahriar",
      },
    ],
  },
  {
    provience: "esfahan",
    city: [
      {
        name: "اصفهان",
        value: "esfahan",
      },
      {
        name: "شاهین شهر",
        value: "shahinshahr",
      },
    ],
  },
];
